<template>
  <span class="block text-main text-lg font-bold leading-tight">{{ text }}</span>
</template>

<script setup lang="ts">
defineProps({
  text: String,
})
</script>
